import React from "react";
import styled from "styled-components";
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Overlay = styled.div`
  position: fixed;
  z-index: 1500;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 41, 52, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  width: 450px;
  height: 210px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 24px;
  top: 24px;
  background: none;
  border: none;
  font-size: 20px;
  color: #AEB8C4;
  cursor: pointer;
`;

const Title = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #1B2028;
  margin-top: 24px;
  margin-bottom: 8px;
  text-align: center;
`;

const Subtitle = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  color: #5A6C87;
  text-align: center;
`;

export default function GeneratingLoader({ open, onClose }) {
  if (!open) return null;

  return (
    <Overlay>
      <Modal>
        <CloseButton onClick={onClose} aria-label="Close">
          &#10005;
        </CloseButton>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        <Title>File is being generated</Title>
        <Subtitle>This can take a few seconds</Subtitle>
      </Modal>
    </Overlay>
  );
}

GeneratingLoader.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};